module.exports = __webpack_public_path__ + "static/blueagave-0327a750c7e8d160b62553d50021772a.png";